import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Route, Routes,HashRouter, Navigate } from 'react-router-dom'
import { Loading } from '../components/Loading'
import { Download } from '../screens/firma/Download'
import { VerPdf } from '../screens/firma/VerPdf'
import { Login } from '../screens/Login'
import { Mfa } from '../screens/Mfa'
import { PrimeraVez } from '../screens/PrimeraVez'
import { RecuperarClave } from '../screens/RecuperarClave'
import { renuew, renuewRepresentante } from '../store/actions/login.actions'
import { NavigationLog } from './NavigationLog'
import { PrivateRoute } from './PrivateRoute'
import { PublicRoute } from './PublicRoute'
import { LoginRepresentante } from '../screens/Representante/LoginRepresentante'
import { NavigationLogRepresentantes } from './Representantes/NavigationLogRepresentantes'
import { HistorialSolicitudes } from '../screens/firma/HistorialSolicitudes'
import { AdminVacaciones } from '../screens/Vacaciones/AdminVacaciones'


export const Navigation = () => {

    const dispatch = useDispatch()

    const autenticado = useSelector(state => state.login.autenticado)
   
    const representante = useSelector(state => state.login.representante)


    const renovarSesion = () => {


      const tipoSesion = localStorage.getItem('appUser')

      if(tipoSesion === 'representante' ){

        dispatch(renuewRepresentante())

        
      }else{
        dispatch(renuew())
      }


    }
   

    useEffect(() => {

      renovarSesion()
    
    }, []);
    


if(autenticado === 'checking') return <div className='marginTopLoading' >
                                           <Loading />
                                      </div> 

  return (
    <HashRouter>
    
      <Routes>
      

       

    
          
          <Route path="/"   element={
                 <PublicRoute>
                   <Login/>
                 </PublicRoute>


          } />

          <Route path="/representante"   element={
                 <PublicRoute>
                   <LoginRepresentante/>
                 </PublicRoute>


          } />

          <Route path="/PrimeraVez"   element={
                 <PublicRoute>
                   <PrimeraVez />
                 </PublicRoute>

          } />
          <Route path="/RecuperarClave"   element={
                 <PublicRoute>
                  <RecuperarClave />
                 </PublicRoute>

          } />

          <Route path="/verpdf/:id/:codper"   element={<VerPdf />} />
          <Route path="/historial/:id/:codper"   element={<HistorialSolicitudes />} />
          <Route path="/download"   element={<Download />} />

          <Route path="/mfa"   element={<Mfa />} />

          <Route path="/admin-vacaciones/:hash/:conid"   element={<AdminVacaciones />} />

 

              

         
        <Route path="/*" element={
         
         <PrivateRoute>

          {
            representante ? <NavigationLogRepresentantes/> : <NavigationLog />
          }
     

         </PrivateRoute>
           
           }
           
            />
     




      </Routes>
   
    
    
    
    </HashRouter>
  )
}
